import React, { FC } from 'react';
import { Container, ContentLoader } from './styles';

const Loader: FC = () => {
  return (
    <Container>
      <ContentLoader viewBox="0 0 486 184">
        <path d="M442.351 22.1398C453.723 18.9737 474.809 17.4212 483.663 16.3271C484.889 16.1756 486 17.1246 486 18.3603V176H81V81.0944C81 77.0785 83.3962 73.4424 87.0695 71.8193C99.4351 66.3555 117.914 58.2171 130.99 58.2169C146.442 58.2167 156.331 63.7728 176.702 65.2425C201.386 67.0236 199.253 67.9874 210.25 70.2532C221.246 72.5189 231.094 73.983 243.352 73.2674C266.349 71.9249 282.096 63.6812 301.367 62.3647C318.827 61.1719 329.48 50.0411 335.026 45.4091C340.817 40.5732 348.619 33.2299 364.15 33.2627C379.68 33.2956 388.682 37.0234 404.495 34.9768C422.593 32.6346 432.741 24.8156 442.351 22.1398Z" />
        <rect width="48" height="16" rx="8" />
        <rect y="168" width="48" height="16" rx="8" />
        <rect y="112" width="48" height="16" rx="8" />
        <rect y="56" width="48" height="16" rx="8" />
      </ContentLoader>
    </Container>
  );
};

export default Loader;
